import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	queues: {
		id: 'servicedesk-queues-breadcrumb.queues-breadcrumb-manager.queues',
		defaultMessage: 'Queues',
		description: 'Title used in breadcrumb used to navigate a queue.',
	},
});
